/** SASE-35 (P35c): while a partner's person manages a customer, every SASE page
 *  says whose organisation it shows, what they may do there, and how to go
 *  back to their own. Shown on SASE pages only (elsewhere the console is the
 *  person's own organisation, and the header is never sent). */
import { useLocation } from "react-router-dom";
import { Alert, Button } from "antd";

import { useActingFor } from "./hooks";

export default function ActingForBanner() {
  const { acting, stopManaging } = useActingFor();
  const { pathname } = useLocation();
  if (!acting || !pathname.startsWith("/sase")) return null;
  const can =
    acting.role === "admin" ? "You can change its settings." : "You can view its settings only.";
  return (
    <Alert
      type="info"
      showIcon
      banner
      data-testid="acting-for-banner"
      style={{ marginBottom: 12 }}
      message={`You are managing ${acting.name} for ${acting.partnerName}.`}
      description={`${can} What you do is recorded in ${acting.name}'s activity under your name.`}
      action={
        <Button size="small" onClick={stopManaging}>
          Back to my organisation
        </Button>
      }
    />
  );
}
